import styles from './BrandMark.module.css';

type BrandMarkVariant = 'full' | 'signet' | 'wordmark';

interface BrandMarkProps {
    variant?: BrandMarkVariant;
    className?: string;
}

const SIGNET_VIEW_BOX = '0 0 706 697';
const FULL_VIEW_BOX = '0 0 4998 697';
const WORDMARK_VIEW_BOX = '833 0 4165 697';

const VIEW_BOXES: Record<BrandMarkVariant, string> = {
    full: FULL_VIEW_BOX,
    signet: SIGNET_VIEW_BOX,
    wordmark: WORDMARK_VIEW_BOX
};

const PRIMARY_BAR = 'M.07,684.12C-.5,411.38,2.48,211.67,6.65,172.79c2.57-23.97,9.94-45.98,9.94-45.98,4.12-12.31,10.62-31.24,25.66-51.47,21.4-28.79,47.04-42.67,58.22-48.57,18.43-9.72,33.66-13.73,48.35-17.5C167.58,4.46,195.39-.68,230.17.07c.17,155.81.34,311.62.51,467.43C153.81,539.71,76.94,611.92,0.07,684.12Z';
const SECONDARY_BAR = 'M241.21 684.09c1.39-373.14 2.37-498.07 3.08-511.45 1.27-23.92 8.72-45.34 8.72-45.34h0c4.12-12.31 10.62-31.24 25.66-51.47 21.4-28.79 47.04-42.67 58.22-48.57 18.43-9.72 33.66-13.73 48.35-17.5C403.99 4.95 431.8-0.19 466.58 0.56c0.17 155.81 0.34 311.62 0.51 467.43l-225.89 216.1h0Z';
const TERTIARY_BAR = 'M480.65 683.68c-0.89-351.13-0.52-482.4 0.45-494.68 0.82-10.39 2.45-20.8 2.45-20.8 1.07-6.86 2.05-11.32 4-20.25 0 0 2.04-9.32 6.17-20.65h0c4.05-12.31 10.45-31.24 25.25-51.47 21.05-28.79 46.28-42.67 57.28-48.57 18.13-9.72 33.11-13.73 47.57-17.5 18.46-4.81 45.82-9.95 80.04-9.2 0.17 155.81 0.34 311.62 0.51 467.43l-223.7 215.69h0ZM704.28 577.63c0.02 35.02 0.05 70.03 0.07 105.05h-109.68l109.61-105.05h0Z';
const WORDMARK = 'M1299.82 685.06V4.93h157.4v680.13h-157.4ZM990.85 4.93v680.13h-157.4V4.93h157.4ZM1311.48 273.09v133.11h-332.29v-133.11h332.29ZM1690.41 685.06h-161.29L1832.26 4.93h155.46l304.11 680.13h-165.17l-248.73-600.46h62.18l-249.7 600.46ZM2115 539.31h-434.31l41.78-119.51h349.78l42.75 119.51ZM2356.93 385.8V4.93h157.4v375.04c0 60.41 11.55 105.04 34.65 133.9 1.65 2.07 3.38 4.07 5.19 6.01 18.23 19.37 41.97 32.69 68.01 38.15 14.36 3.17 29.03 4.71 43.73 4.6 15.36 0.12 30.68-1.57 45.64-5.05 25.31-5.67 48.33-18.8 66.1-37.7 10.96-12.1 19.45-26.23 25-41.58 9.89-26.02 14.84-58.8 14.84-98.34V4.93h155.46v380.87c0.22 30.48-2.72 60.9-8.78 90.76-12 56.88-36.27 103.39-72.83 139.51-35.12 34.22-78.93 58.18-126.69 69.3-30.27 7.56-63.51 11.34-99.7 11.34-30.95 0.24-61.82-2.96-92.07-9.53-42.9-9.67-80.05-26.68-111.44-51.05-8.02-6.23-15.66-12.93-22.88-20.07-54.41-53.76-81.62-130.52-81.62-230.27ZM3284.82 685.06h-156.43V4.93h156.43v680.13ZM3380.04 413.98l-110.76 115.62-8.74-181.69L3586.02 4.93h174.89l-293.43 315.77-87.44 93.27ZM3777.43 685.06h-183.63l-241.93-296.34 102.99-111.74 322.57 408.08ZM4003.81 131.24v427.51h370.18v126.31h-526.61V4.93h513.98v126.31h-357.55ZM3992.15 401.35v-122.42h327.43v122.42h-327.43ZM4997.77 685.06h-498.44V4.93h157.4v551.87h341.04v128.25Z';

export default function BrandMark({ variant = 'full', className }: BrandMarkProps) {
    const showsSignet = variant !== 'wordmark';
    const showsWordmark = variant !== 'signet';

    return (
        <svg
            className={[styles.mark, className].filter(Boolean).join(' ')}
            viewBox={VIEW_BOXES[variant]}
            aria-hidden="true"
            focusable="false"
            fill="currentColor"
        >
            {showsSignet && (
                <>
                    <path d={PRIMARY_BAR} />
                    <path d={SECONDARY_BAR} />
                    <path d={TERTIARY_BAR} />
                </>
            )}
            {showsWordmark && <path d={WORDMARK} />}
        </svg>
    );
}
